import { Theme, ThemeProvider } from "@ews-admin/global-design-system";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { initAnalytics } from "./analytics/ga";
import "./i18n"; // Import i18n configuration
import "./index.css";
import { store } from "./store/store";
import { envConfig } from "./utils/config-utils";

// Google Analytics 4 — inert unless the prod image build supplies VITE_GA_MEASUREMENT_ID.
initAnalytics({
  measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
  enabled: envConfig.env === "prod",
  consentGated: false,
});

// PROMED = the logo colours (#21596C primary, #3BA1A1 secondary), like Medecine360-ui and login
const DEFAULT_THEME: Theme = "PROMED";
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider defaultTheme={DEFAULT_THEME}>
        <App />
      </ThemeProvider>
    </Provider>
  </StrictMode>,
);
